import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { LayoutDashboard, Package, FolderTree, ShoppingCart, Boxes, Settings, LogOut, Menu, X, ExternalLink, FileText, BellRing } from "lucide-react";

const LINKS = [
  { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard, end: true, testid: "nav-dashboard" },
  { to: "/admin/produits", label: "Produits", icon: Package, testid: "nav-produits" },
  { to: "/admin/collections", label: "Collections", icon: FolderTree, testid: "nav-collections" },
  { to: "/admin/commandes", label: "Commandes", icon: ShoppingCart, testid: "nav-commandes" },
  { to: "/admin/inventaire", label: "Inventaire", icon: Boxes, testid: "nav-inventaire" },
  { to: "/admin/alertes", label: "Demandes « Prévenez-moi »", icon: BellRing, testid: "nav-alertes" },
  { to: "/admin/contenu", label: "Contenu du site", icon: FileText, testid: "nav-contenu" },
  { to: "/admin/parametres", label: "Paramètres", icon: Settings, testid: "nav-parametres" },
];

export default function AdminLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => { logout(); navigate("/admin/login"); };

  const Sidebar = () => (
    <div className="flex h-full flex-col">
      <div className="border-b border-white/10 p-6">
        <img src="/logo-yoyo.png" alt="Le Dressing de Yoyo" className="h-20 w-auto" />
        <p className="mt-1 text-[10px] uppercase tracking-[0.2em] text-[#9B7E73]">Administration</p>
      </div>
      <nav className="flex-1 space-y-1 p-4">
        {LINKS.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.end}
            data-testid={l.testid}
            onClick={() => setOpen(false)}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-medium transition-colors ${
                isActive ? "bg-[#D76E4D] text-white" : "text-[#D8C5BD] hover:bg-white/5"
              }`
            }
          >
            <l.icon className="h-5 w-5" /> {l.label}
          </NavLink>
        ))}
      </nav>
      <div className="space-y-1 border-t border-white/10 p-4">
        <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 rounded-lg px-4 py-3 text-sm text-[#D8C5BD] hover:bg-white/5">
          <ExternalLink className="h-5 w-5" /> Voir la boutique
        </a>
        <button onClick={handleLogout} data-testid="logout-button" className="flex w-full items-center gap-3 rounded-lg px-4 py-3 text-sm text-[#D8C5BD] hover:bg-white/5">
          <LogOut className="h-5 w-5" /> Déconnexion
        </button>
      </div>
    </div>
  );

  return (
    <div className="flex min-h-screen bg-[#F5E8E3]">
      <aside className="hidden w-64 shrink-0 bg-[#2C1A14] lg:block">
        <Sidebar />
      </aside>

      {open && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setOpen(false)} />
          <aside className="absolute left-0 top-0 h-full w-64 bg-[#2C1A14]">
            <button onClick={() => setOpen(false)} className="absolute right-3 top-3 text-white"><X /></button>
            <Sidebar />
          </aside>
        </div>
      )}

      <div className="min-w-0 flex-1">
        <header className="flex items-center justify-between border-b border-[#E8D5CE] bg-white px-4 py-3 lg:hidden">
          <button onClick={() => setOpen(true)} data-testid="admin-mobile-menu"><Menu className="text-[#2C1A14]" /></button>
          <img src="/logo-yoyo.png" alt="Le Dressing de Yoyo" className="h-16 w-auto" />
          <span className="w-6" />
        </header>
        <main className="p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
